'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');

const InteractiveTagContext = React.createContext(void 0);
const InteractiveTagProvider = ({ children }) => {
  const [body, setBody] = React.useState(void 0);
  const [title, setTitle] = React.useState(void 0);
  const [isTruncated, setIsTruncated] = React.useState(false);
  return jsxRuntime.jsx(InteractiveTagContext.Provider, { value: { body, isTruncated, setBody, setTitle, setIsTruncated, title }, children });
};
const useInteractiveTagContext = () => {
  const context = React.useContext(InteractiveTagContext);
  if (context === void 0) {
    throw new Error("useInteractiveTagContext must be used within an InteractiveTagProvider (which is available by using InteractiveTag or InteractiveTagWrapper)");
  }
  return context;
};

exports.InteractiveTagContext = InteractiveTagContext;
exports.InteractiveTagProvider = InteractiveTagProvider;
exports.useInteractiveTagContext = useInteractiveTagContext;
//# sourceMappingURL=InteractiveTagContext.cjs.js.map
